import React from "react";
import "./Trip.css";
import TripData from "./TripData";
import Trip1 from "../assets/TripImg1.jpg";
import Trip2 from "../assets/travel2.jpg";
import Trip3 from "../assets/travel3.jpg";

const Trip = () => {
  return (
    <div className="trip">
      <h1>Recent Trip</h1>
      <p>You can discover unique destination using google maps.</p>

      <div className="tripcard">
        <TripData
          image={Trip1}
          heading="Trip in Himalaya"
          text="Embark on a transformative Himalayan journey, where soaring peaks and spiritual serenity converge. Trek through picturesque landscapes, explore ancient monasteries, and encounter diverse cultures. The Himalayas offer a profound escape, blending awe-inspiring natural beauty with spiritual richness, making every step a moment of discovery and connection with the sublime."          
        />

        <TripData
          image={Trip2}
          heading="Trip in Goa"
          text="Goa is a state in western India with coastlines stretching along the Arabian Sea. Its long history as a Portuguese colony prior to 1961 is evident in its preserved 17th-century churches and the area’s tropical spice plantations. Goa is also known for its beaches, ranging from popular stretches at Baga and Palolem to those in laid-back fishing villages such as Agonda."
        />

        <TripData
          image={Trip3}
          heading="Trip in Laddakh"
          text="
          A trip to Ladakh is an odyssey through stark, breathtaking landscapes and ancient monastic heritage. Marvel at the indigo hues of Pangong Lake, traverse high-altitude mountain passes, and explore centuries-old monasteries perched on dramatic cliffs. Ladakh's serene beauty and cultural richness create an unforgettable expedition into the heart of the Himalayas."
        />
      </div>
    </div>
  );
};

export default Trip;
